import { Box, Stack, TextField, Typography } from '@atgfr8/atg-ui-tailwind';
import { ToastType } from '@components';
import { AtgLoader } from '@components/AtgLoader';
import {
  blacklistCarrier,
  carrierDetailsStore,
  updateCarrierDetailsState,
} from '@store/carriers';
import { setCarrierStore } from '@store/orders';
import { userStore } from '@store/user';
import type { ChangeTrackingSource } from '@typeDefinitions/changeTrackingTypes';
import { handleToast } from '@utils/utils';
import { Component, createSignal, Show } from 'solid-js';

import cls from './classes';

type CarrierDetailsBlacklistProps = {
  closePopover: () => void;
  carrierId: number | undefined;
  tabIndex?: number;
  changeTrackingSource?: ChangeTrackingSource;
};

export const CarrierDetailsBlacklist: Component<
  CarrierDetailsBlacklistProps
> = (props) => {
  const [comment, setComment] = createSignal('');
  const [loading, setLoading] = createSignal(false);

  const onSubmit = async (e: KeyboardEvent) => {
    if (
      Boolean(props.carrierId) &&
      !loading() &&
      e.key === 'Enter' &&
      !e.shiftKey &&
      comment().length > 0
    ) {
      setLoading(true);
      const res = await blacklistCarrier({
        id: props.carrierId!,
        comment: comment(),
        changeTrackingSource: props.changeTrackingSource,
      });
      if (Boolean(res)) {
        if (carrierDetailsStore.carrierDetails) {
          updateCarrierDetailsState({
            blacklist: {
              bannedBy: userStore.user.name,
              comment: comment(),
              bannedDate: new Date().toISOString(),
              carrierId: props.carrierId!,
              id: 0,
              officeId: userStore.user.officeId,
            },
          });
        }

        if (props.tabIndex !== undefined) {
          setCarrierStore('carrier', props.tabIndex, 'blacklisted', true);
        }
        handleToast(
          ToastType.Success,
          'The Carrier has been blacklisted for your office',
        );
        props.closePopover();
      }
      setLoading(false);
    }
  };

  return (
    <Stack spacing={1} minWidth={350} maxWidth={'90%'}>
      <Show
        when={!loading()}
        fallback={
          <Box class="h-[600px] fixed top-[50%] left-[50%]">
            <AtgLoader />
          </Box>
        }
      >
        <Box backgroundColor="#F5F5F5" class="px-2 py-1">
          <Typography
            variant="body1"
            component="p"
            class={cls.blacklistCommentTitle}
          >
            Enter a Comment
          </Typography>
        </Box>
        <Box class="px-3 pt-2 pb-3">
          <TextField
            label="Comment"
            multiline
            value={comment()}
            onChange={(e: string) => setComment(e)}
            rows={4}
            fullWidth
            maxLength={2000}
            onKeyPress={onSubmit}
            dataTestId="carrier-details-blacklist-comment-textInput"
          />
        </Box>
      </Show>
    </Stack>
  );
};
